import AxiosInstance from "../../AxiosInstance";

const BillingbaseUrl = '/operation';
const MasterbaseUrl = '/master';
// const billingmasterUrl = 'master/billing';
const ObmasterUrl = 'ob/billing';
// const ReportsbaseUrl = '/Reports';

const PaymentExpensesServices = {

    //getImporterDetails
    getImporterDetails: () => {
        return AxiosInstance.get(MasterbaseUrl+'/getImporterDetails');
    },

    //getJobNoBasedImpCMNonUploadCL
    getJobNoBasedImpCMNonUploadCL:(originEntryVO)=>{
        return AxiosInstance.post(BillingbaseUrl+'/getJobNoBasedImpCMNonUploadCL',originEntryVO);
    },
    //getJobNoBasedImpCMUploadCL
    getJobNoBasedImpCMUploadCL:(originEntryVO)=>{
        return AxiosInstance.post(BillingbaseUrl+'/getJobNoBasedImpCMUploadCL',originEntryVO);
    },

    //insertDutyPayment
    insertDutyPayment:(originEntryVO)=>{
        return AxiosInstance.post(BillingbaseUrl+'/insertDutyPayment',originEntryVO);
    },

    //updateDutyPayment
    updateDutyPayment:(originEntryVO)=>{
        return AxiosInstance.put(BillingbaseUrl+'/updateDutyPayment',originEntryVO);
    },

    //deleteDutyPayment
    deleteDutyPayment:(consignmentId)=>{
        return AxiosInstance.delete(BillingbaseUrl+'/deleteDutyPayment?consignmentId='+consignmentId)
    },

    //insertTspPayment
    insertTspPayment:(originEntryVO)=>{
        return AxiosInstance.post(BillingbaseUrl+'/insertTspPayment',originEntryVO);
    },

    //updateTspPayment
    updateTspPayment:(originEntryVO)=>{
        return AxiosInstance.put(BillingbaseUrl+'/updateTspPayment',originEntryVO);
    },

    //deleteTspPayment
    deleteTspPayment:(consignmentId)=>{
        return AxiosInstance.delete(BillingbaseUrl+'/deleteTspPayment?consignmentId='+consignmentId);
    },

    //insertAllPayment
    insertAllPayment:(originEntryVO)=>{
        return AxiosInstance.post(BillingbaseUrl+'/insertAllPayment',originEntryVO);
    },

    //updateAllPayment
    updateAllPayment:(originEntryVO)=>{
        return AxiosInstance.put(BillingbaseUrl+'/updateAllPayment',originEntryVO);
    },

    //deleteAllPayment
    deleteAllPayment:(consignmentId,tspPaidTo)=>{
        return AxiosInstance.delete(BillingbaseUrl+'/deleteAllPayment?consignmentId='+consignmentId+'&tspPaidTo='+tspPaidTo);
    },
    //getConsignmentJobEntryAssign
    getConsignmentJobEntryAssign:(consignmentId)=>{
        return AxiosInstance.get(BillingbaseUrl+'/getConsignmentJobEntryAssign?consignmentId='+consignmentId)
    },

    //getDutyPayment
    getDutyPayment:(consignmentId)=>{
        return AxiosInstance.get(BillingbaseUrl+'/getDutyPayment?consignmentId='+consignmentId)
    },
    //getTspPayment
    getTspPayment:(consignmentId)=>{
        return AxiosInstance.get(BillingbaseUrl+'/getTspPayment?consignmentId='+consignmentId)
    },
    //getAllPayment
    getAllPayment:(consignmentId,billType)=>{
        return AxiosInstance.get(BillingbaseUrl+'/getAllPayment?consignmentId='+consignmentId+'&billType='+billType)
    },
    //getbillName
    getbillName:(billType)=>{
        return AxiosInstance.get(ObmasterUrl+'/getbillName?billType='+billType)
    },
    //getJobTrackingDetails
    getJobTrackingDetails:(consignmentId)=>{
        return AxiosInstance.get(BillingbaseUrl+'/getJobTrackingDetails?consignmentNumber='+consignmentId)
    },
  
};

export default PaymentExpensesServices;